<template>
	<div class="container" :class="expanded ? '' : 'not-expanded'">
		<div class="faq-toggle header">
			<h3>{{ header }}</h3>
			<div v-if="expanded" class="toggle-arrow arrow-up" />
			<div v-else class="toggle-arrow arrow-down" />
		</div>
		<div class="faq-content content">
			<div v-parse-links v-html="content" />
		</div>
	</div>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	expanded: { type: Boolean, default: true },
});
</script>

<style lang="scss" scoped>
.faq-content {
	padding: 5px 0 30px;

	p:last-child,
	:deep(p:last-child) {
		margin: 0;
	}
}

.faq-toggle {
	cursor: pointer;
	background: #fff;
	transition: all 0.3s ease-in-out;
	position: relative;
	font-weight: 700;
	padding: 26px 0;
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;

	h3 {
		font-size: 16px;
		font-family: var(--body-font-family);
		font-weight: 700;
		margin: 0;
		text-transform: none;
		letter-spacing: 0;
	}
}

.filter-select {
	padding: 25px 0;
}

.toggle-arrow {
	width: 46px;
	height: 12px;
	background: url('~/assets/images/filter-arrow-down.svg') no-repeat center center;
	background-size: 46px;

	&.arrow-up {
		background: url('~/assets/images/filter-arrow-up.svg') no-repeat center center;
		background-size: 46px;
	}
}

.header {
	cursor: pointer;
	transition: all 0.3s ease-in-out;
}

.container {
	display: inline-block;
	vertical-align: top;
	text-align: left;
	width: 100%;
	overflow: hidden;

	.content {
		transition: all 300ms ease;

		ul,
		ol {
			padding: 0 0 0 20px;
		}
	}

	&.not-expanded .content {
		transform: scaleY(0);
		transform-origin: top;
		opacity: 0;
		height: 0;
		padding: 0 20px;
	}
}
</style>
